<wl-experience-editor>
  <ng-template wlLive>
    <div
      sc-placeholder
      name="page-solo-row-container"
      [rendering]="rendering"
      class="row-container"
      [clientOnly]="true"
      [ngClass]="[backgroundTheme, textTheme]"
      [ngStyle]="backgroundImageCss"
    >
      <wl-skeleton-loading-row *scPlaceholderLoading></wl-skeleton-loading-row>
    </div>
  </ng-template>
  <ng-template wlPreview>
    <div
      sc-placeholder
      name="page-solo-row-container"
      [rendering]="rendering"
      class="row-container"
      [ngClass]="[backgroundTheme, textTheme]"
      [ngStyle]="backgroundImageCss"
    ></div>
  </ng-template>
</wl-experience-editor>
